import { type ChangeEvent, PureComponent } from "react";
import { Trans, type WithTranslation, withTranslation as withTranslationBase } from "react-i18next";
import { BulkUploadSource, BulkUploadState, type Msg } from "~/features/bulkAddToCart/types/models";
import { TextField, Typography, styled } from "~/common/mui";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";
import { C_ON_SURFACE_VARIANT } from "~/common/components/icon/Colors";
import { DateFormatType, formatDate } from "~/common/utils/DateFormatter";

interface TextUploadSectionProps extends WithTranslation {
  onTextSubmit: (value: string) => void;
  onTextChange: (value: string) => void;
  text: string;
  state: BulkUploadState;
  source: BulkUploadSource;
  messages: Msg[];
}

class TextUploadSection extends PureComponent<TextUploadSectionProps> {
  updateText = (e: ChangeEvent<HTMLTextAreaElement>) => this.props.onTextChange(e.target.value);
  submit = () => this.props.onTextSubmit(this.props.text);

  render() {
    const { state, source, messages, t, text } = this.props;
    const inputDisabled = state === BulkUploadState.UPLOADING;
    const isInvalid = state === BulkUploadState.ERROR && source === BulkUploadSource.TEXT;
    const todayDate = formatDate(new Date(), DateFormatType.DATE);

    const helperText = (
      <Trans
        i18nKey="bulkUpload.text.helperText"
        values={{ dateFormat: todayDate }}
        components={[<Typography component="i" sx={{ fontWeight: "bold" }} />]}
      />
    );

    const helperMsg = messages.length !== 0 ? messages.map((msg) => msg.label).join(" \n") : helperText;

    const placeholderLabel = t("bulkUpload.enter.text");

    return (
      <div className={"d-flex flex-direction-column w-100 flex-justify-center  h-100"}>
        <TextAreaContainer>
          <TextField
            variant={"outlined"}
            multiline
            fullWidth
            value={text}
            placeholder={placeholderLabel}
            data-test-id={"bulk-upload-input-text"}
            onChange={this.updateText}
            disabled={inputDisabled}
            error={isInvalid}
            helperText={helperMsg}
            FormHelperTextProps={{
              sx: {
                ...getFontStyle(FontSize.BodySmall),
                color: C_ON_SURFACE_VARIANT,
                margin: "4px 16px 0 16px",
              },
            }}
            inputProps={{ sx: { height: `${140}px !important` } }}
            InputLabelProps={{ shrink: true }}
          />
        </TextAreaContainer>
      </div>
    );
  }
}

export default withTranslationBase()(TextUploadSection);

const TextAreaContainer = styled("div")({
  position: "relative",
  display: "flex",
  marginBottom: "30px",
  justifyContent: "space-between",
});
